import intermind from '../../../index';
import { ChatMessage } from '../types/chat.types';

export class ChatResource {
  async list(conferenceId: string): Promise<ChatMessage[]> {
    const { data } = await intermind.httpClient.get<ChatMessage[]>(`/conferences/${conferenceId}/messages`);
    return data;
  }

  async sendMessageToAll(conferenceId: string, fromParticipantId: string, text: string): Promise<void> {
    await intermind.httpClient.post(`/conferences/${conferenceId}/messages`, {
      participantId: fromParticipantId,
      text,
    });
  }
}
